export default {
    methods: {
        isOSX() {
            return navigator.userAgent.indexOf('Mac OS X') != -1
        }
    }
}